// Varsayılan reklamlar — mobildeki slider içerikleriyle uyumlu (seed / ilk Firebase yüklemesi)
export const seedAds = [
  {
    id: "ad-home-1",
    title: "Karadeniz Turları %30 İndirimli",
    subtitle: "Sınırlı süre — hemen rezerve edin!",
    imageUrl: "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=800&q=80",
    backgroundColor: "#1B4332",
    linkUrl: "",
    placement: "home",
    sortOrder: 1,
    isActive: true,
  },
  {
    id: "ad-home-2",
    title: "Rize Çay Bahçeleri Deneyimi",
    subtitle: "Doğanın kalbinde unutulmaz bir gün",
    imageUrl: "https://images.unsplash.com/photo-1564890369478-c89ca6d9cde9?w=800&q=80",
    backgroundColor: "#064E3B",
    linkUrl: "",
    placement: "home",
    sortOrder: 2,
    isActive: true,
  },
  {
    id: "ad-home-3",
    title: "Trabzon Uzungöl Otel Fırsatları",
    subtitle: "Erken rezervasyona özel fiyatlar",
    imageUrl: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&q=80",
    backgroundColor: "#1E3A5F",
    linkUrl: "",
    placement: "home",
    sortOrder: 3,
    isActive: true,
  },
  {
    id: "ad-map-1",
    title: "Karadeniz Turları %30 İndirimli",
    subtitle: "Sınırlı süre — hemen rezerve edin!",
    imageUrl: "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=800&q=80",
    backgroundColor: "#1B4332",
    linkUrl: "",
    placement: "map",
    sortOrder: 1,
    isActive: true,
  },
  {
    id: "ad-map-2",
    title: "Rize Çay Bahçeleri Deneyimi",
    subtitle: "Doğanın kalbinde unutulmaz bir gün",
    imageUrl: "https://images.unsplash.com/photo-1564890369478-c89ca6d9cde9?w=800&q=80",
    backgroundColor: "#064E3B",
    linkUrl: "",
    placement: "map",
    sortOrder: 2,
    isActive: true,
  },
  {
    id: "ad-map-3",
    title: "Trabzon Uzungöl Otel Fırsatları",
    subtitle: "Erken rezervasyona özel fiyatlar",
    imageUrl: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&q=80",
    backgroundColor: "#1E3A5F",
    linkUrl: "",
    placement: "map",
    sortOrder: 3,
    isActive: true,
  },
  {
    id: "ad-deals-1",
    title: "Karadeniz Turları %30 İndirimli",
    subtitle: "Sınırlı süre — hemen rezerve edin!",
    imageUrl: "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=800&q=80",
    backgroundColor: "#1B4332",
    linkUrl: "",
    placement: "deals",
    sortOrder: 1,
    isActive: true,
  },
  {
    id: "ad-deals-2",
    title: "Rize Çay Bahçeleri Deneyimi",
    subtitle: "Doğanın kalbinde unutulmaz bir gün",
    imageUrl: "https://images.unsplash.com/photo-1564890369478-c89ca6d9cde9?w=800&q=80",
    backgroundColor: "#064E3B",
    linkUrl: "",
    placement: "deals",
    sortOrder: 2,
    isActive: true,
  },
  {
    id: "ad-deals-3",
    title: "Erken Rezervasyon Fırsatları",
    subtitle: "Yaz tatili için şimdiden planlayın",
    imageUrl: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&q=80",
    backgroundColor: "#1E3A5F",
    linkUrl: "",
    placement: "deals",
    sortOrder: 3,
    isActive: true,
  },
  {
    id: "ad-biz-1",
    title: "Karadeniz Otelleri %25 İndirimli",
    subtitle: "Seçili otellerde erken rezervasyon fırsatı",
    imageUrl: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80",
    backgroundColor: "#1B4332",
    linkUrl: "",
    placement: "businesses",
    sortOrder: 1,
    isActive: true,
  },
  {
    id: "ad-biz-2",
    title: "Yerel Lezzetler Sizi Bekliyor",
    subtitle: "En iyi Karadeniz restoranları",
    imageUrl: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&q=80",
    backgroundColor: "#7C2D12",
    linkUrl: "",
    placement: "businesses",
    sortOrder: 2,
    isActive: true,
  },
  {
    id: "ad-biz-3",
    title: "Butik Pansiyonlarda Huzur",
    subtitle: "Doğanın içinde konaklama ayrıcalığı",
    imageUrl: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800&q=80",
    backgroundColor: "#1E3A5F",
    linkUrl: "",
    placement: "businesses",
    sortOrder: 3,
    isActive: true,
  },
];
